import { api } from '../client';

export interface PlaceSuggestion {
  placeId: string;
  primaryText: string;
  secondaryText: string;
  fullText: string;
}

export interface PlaceDetail {
  placeId: string;
  formattedAddress: string;
  city: string;
  district?: string;
  state: string;
  pincode: string;
  lat: number;
  lng: number;
}

/**
 * Searches address suggestions matching `input` via the backend's Google
 * Places proxy (mirrors rhino_core's PlacesApi.autocomplete). Requires a
 * minimum of 3 characters. Pass `sessionToken` (a UUID) to group an
 * autocomplete+details round trip for Places billing.
 */
export async function placesAutocomplete(
  input: string,
  sessionToken?: string,
): Promise<PlaceSuggestion[]> {
  if (input.trim().length < 3) return [];
  const { data } = await api.get<PlaceSuggestion[]>('/places/autocomplete', {
    params: {
      input: input.trim(),
      ...(sessionToken ? { sessionToken } : {}),
    },
  });
  return data;
}

/** Fetches structured place details for a selected `placeId`. */
export async function getPlaceDetails(
  placeId: string,
  sessionToken?: string,
): Promise<PlaceDetail> {
  const { data } = await api.get<PlaceDetail>(`/places/${placeId}`, {
    params: sessionToken ? { sessionToken } : {},
  });
  return data;
}

export interface DistanceResult {
  distanceKm: number;
  estimatedDurationMinutes: number;
  isEstimated: boolean;
}

/**
 * Calculates road distance and estimated commercial freight transit duration.
 */
export async function getDistance(
  originLat: number,
  originLng: number,
  destLat: number,
  destLng: number,
): Promise<DistanceResult> {
  const { data } = await api.get<DistanceResult>('/places/distance', {
    params: { originLat, originLng, destLat, destLng },
  });
  return data;
}


